import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import Wysiwyg from '../wysiwyg';
import Promo from '../promo';
import Video from '../video';
import Presentation from '../presentation';
import Picker from '../picker';
import OneColumnLayout from '../one-column-layout';
import TwoColumnLayout from '../two-column-layout';
import ThreeColumnLayout from '../three-column-layout';
import FourColumnLayout from '../four-column-layout';
import * as blocks from "../../blocks";
import './styles.css';

/**
 *  AccessoryInfoItem
 */
class AccessoryInfoItem extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    components: PropTypes.array
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    components: null
  };
  
  constructor(props) {
    super();
    this.props = props;
  }
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      components
    } = this.props;
        
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <div className='AccessoryInfoItem'>
          <div className='AccessoryInfoItem__container'>
            {components.map((component, index) => {
              if(component.name === 'Wysiwyg'){
                return(
                  <Wysiwyg {...component.props} key={index} />
                )
              }
              else if(component.name === 'Promo'){
                return(
                  <Promo {...component.props} key={index} />
                )
              }
              else if(component.name === 'Video'){
                return(
                  <Video {...component.props} key={index} />
                )
              }
              else if(component.name === 'Presentation'){
                let Block = blocks[component.name];
                if (Block) {
                  return <Block {...component.props} key={index}/>
                }
              }
              else if(component.name === 'Picker'){
                return(
                  <Picker {...component.props} key={index} />
                )
              }
              else if(component.name === 'OneColumnLayout'){
                return(
                  <OneColumnLayout {...component.props} key={index} />
                )
              }
              else if(component.name === 'TwoColumnLayout'){
                return(
                  <TwoColumnLayout {...component.props} key={index} />
                )
              }
              else if(component.name === 'ThreeColumnLayout'){
                return(
                  <ThreeColumnLayout {...component.props} key={index} />
                )
              }
              else if(component.name === 'FourColumnLayout'){
                return(
                  <FourColumnLayout {...component.props} key={index} />
                )
              }
            })}
          </div>
        </div>
      </Wrapper>
    )
  }
  
}

export default AccessoryInfoItem;



// WEBPACK FOOTER //
// ./src/containers/accessory-info-item/index.jsx